module.exports = fox._r("images/check_mark.png", __webpack_public_path__ + "_/_/_/affiliate/images/check_mark.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/affiliate/images/check_mark.png
// module id = 190
// module chunks = 4